const { protocol, hostname } = document.location;

const match = hostname.match(/(liepin|wisest|lietou|tongdao).([0-9a-z]+)$/) || [];
const [, domain = 'liepin', suffix = 'com'] = match;
export const isCn = suffix === 'cn';
export const isCom = suffix === 'com';
export const baseDomain = `${domain}.${suffix}`;
export default (sub) => {
  return sub
    ? `${protocol}//${sub.replace(/\.$/g, '')}.${baseDomain}`
    : baseDomain;
};




